import PropTypes from 'prop-types';
import React from 'react';
import { Button } from 'react-bootstrap';

import Icon from '../common/Icon';

const Link = ({ channel }) => {
	return <Button
		href={channel.stream_link}
		rel="noreferrer"
		target="_blank"
		title={channel.title}
		variant="outline-twitch"
	>
		<Icon.STREAM />
		&nbsp;
		{channel.short_name || channel.title}
	</Button>;
};

Link.propTypes = {
	channel: PropTypes.shape({
		short_name: PropTypes.string,
		stream_link: PropTypes.string,
		title: PropTypes.string,
	}),
};

export default Link;
